import { H3 } from 'components/typography'
import { FC, PropsWithChildren } from 'react'

// Looks like an H3 but is a block <span>: **bold** sits inside a Markdown <p> (an <h3> there breaks hydration
// of the server-rendered Datafolha pages).
const MarkdownStrong: FC<PropsWithChildren> = ({ children }) => {
  return (
    <H3 as="span" display="block" fontWeight={700}>
      {children}
    </H3>
  )
}

export default MarkdownStrong
